import { HANDLE_SNACKBAR } from "redux/TypeConstant";

const SnackReducer = (
  state = {
    snackbar: {
      show: false,
      severity: "success",
      text: "متن تست",
    },
  },
  action
) => {
  switch (action.type) {
    case HANDLE_SNACKBAR:
      return {
        ...state,
        snackbar: {
          show: action.show,
          severity: action.severity,
          text: action.text,
        },
      };
    default:
      return state;
  }
};

export default SnackReducer;
